import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Subject, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Note, UpdateNoteRequest } from "../models/note.model";
import { NoteType } from "../models/note-type.enum";
import { NoteRelatedItemType } from "../models/note_relatedItemType.enum";



@Injectable({
    providedIn: 'root'
})
export class CriticalNoteService {

    readonly BASE_URL: string = "/api/notes"

    private noteAdded$: Subject<Note> = new Subject<Note>();
    private noteDeleted$: Subject<Note> = new Subject<Note>();
    private noteDemoted$: Subject<Note> = new Subject<Note>();

    noteAddedObs$: Observable<Note> = this.noteAdded$.asObservable();
    noteDeletedObs$: Observable<Note> = this.noteDeleted$.asObservable();
    noteDemotedObs$: Observable<Note> = this.noteDemoted$.asObservable();
    //need hooks for demoted/deleted to be able to tie over to organization-notes

    constructor(private client: HttpClient) { }

    demoteNote(noteId: string, type: NoteType, itemType: NoteRelatedItemType): Observable<Note> {
        let request: UpdateNoteRequest = {
            noteId: noteId,
            updatedType: type,
            itemType: itemType
        } as UpdateNoteRequest;
        return this.client.post<Note>(`${this.BASE_URL}/update`, request);
    }

    deleteNote(noteId: string, itemType: NoteRelatedItemType): Observable<Note> {
        let request = {
            noteId: noteId,
            itemType: itemType,
            deletedState: true
        } as UpdateNoteRequest;
        return this.client.post<Note>(`${this.BASE_URL}/update`, request);
    }

    saveNote(note: Note): Observable<Note> {
        let path = this.BASE_URL;
        return this.client.post<Note>(path, note).pipe(
            tap((note: Note) => {
                this.noteAdded$.next(note);
            })
        );
    }
}
